export const jsonEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
